import { format, register } from 'timeago.js';

const tradsFR = (number, index, totalSec) => {
	return [
		['A l\'instant', 'Maintenant'],
		['il y a %s secondes', 'dans %s secondes'],
		['Il y a 1 minute', 'dans 1 minute'],
		['Il y a %s minutes', 'dans %s minutes'],
		['Il y a 1 heure', 'dans 1 heure'],
		['Il y a %s heures', 'dans %s heures'],
		['Il y a 1 jour', 'dans 1 jour'],
		['Il y a %s jours', 'dans %s jours'],
		['Il y a 1 semaine', 'dans 1 semaine'],
		['Il y a %s semaines', 'dans %s semaines'],
		['Il y a 1 mois', 'dans 1 mois'],
		['Il y a %s mois', 'dans %s mois'],
		['Il y a 1 an', 'dans 1 an'],
		['Il y a %s ans', 'dans %s ans']
	][index];
};

const tradsIT = (number, index, totalSec) => {
	return [
		['proprio ora', 'proprio ora'],
		['%s secondi fa', 'tra %s secondi'],
		['1 minuto fa', 'tra 1 minuto'],
		['%s minuti fa', 'in %s minuti'],
		['1 ora fa', 'in 1 ora'],
		['%s ore fa', 'in %s ore'],
		['1 giorno fa', 'in 1 giorno'],
		['%s giorni fa', 'in %s giorni'],
		['1 settimana fa', 'in 1 settimana'],
		['%s settimane fa', 'in %s settimane'],
		['1 mese fa', 'in 1 mese'],
		['%s mesi fa', 'in %s mesi'],
		['1 anno fa', 'in 1 anno'],
		['%s anni fa', 'in %s anni']
	][index];
};

const tradsES = (number, index, totalSec) => {
	return [
		['ahora mismo', 'ahora mismo'],
		['hace %s segundos', 'en %s segundos'],
		['hace 1 minuto', 'en 1 minuto'],
		['hace %s minutos', 'en %s minutos'],
		['hace 1 hora', 'en 1 hora'],
		['hace %s horas', 'en %s horas'],
		['hace 1 día', 'en 1 día'],
		['hace %s días', 'en %s días'],
		['hace 1 semana', 'en 1 semana'],
		['hace %s semanas', 'en %s semanas'],
		['hace 1 mes', 'en 1 mes'],
		['hace %s meses', 'en %s meses'],
		['hace 1 año', 'en 1 año'],
		['hace %s años', 'en %s años']
	][index];
};

const tradsPT = (number, index, totalSec) => {
	return [
		['agora mesmo', 'neste momento'],
		['%s segundos atrás', 'em %s segundos'],
		['1 minuto atrás', 'em 1 minuto'],
		['%s minutos atrás', 'em %s minutos'],
		['1 hour ago', 'in 1 hour'],
		['%s hours ago', 'in %s hours'],
		['1 day ago', 'in 1 day'],
		['%s dias atrás', 'em %s dias'],
		['1 week ago', 'in 1 week'],
		['%s weeks ago', 'in %s weeks'],
		['1 month ago', 'in 1 month'],
		['%s months ago', 'in %s months'],
		['1 year ago', 'in 1 year'],
		['%s years ago', 'in %s years']
	][index];
};

const tradsDE = (number, index, totalSec) => {
	return [
		['just now', 'right now'],
		['seit %s Sekunden', 'in %s Sekunden'],
		['seit 1 Minute', 'in 1 Minute'],
		['seit %s Minuten', 'in %s Minuten'],
		['seit 1 Stunde', 'in 1 Stunde'],
		['seit %s Stunden', 'in %s Stunden'],
		['seit 1 Tag', 'in 1 Tag'],
		['seit %s Tagen', 'in %s Tagen'],
		['seit 1 Woche', 'in 1 Woche'],
		['seit %s Wochen', 'in %s Wochen'],
		['seit 1 Monat', 'in 1 Monat'],
		['seit %s Monaten', 'in %s Monaten'],
		['seit 1 Jahr', 'in 1 Jahr'],
		['seit %s Jahren', 'in %s Jahren']
	][index];
};

const tradsNL = (number, index, totalSec) => {
	return [
		['zojuist', 'op dit moment'],
		['%s seconden geleden', 'over %s seconden'],
		['1 minuut geleden', 'over 1 minuut'],
		['%s minuten geleden', 'over %s minuten'],
		['1 uur geleden', 'over 1 uur'],
		['%s uren geleden', 'over %s uren'],
		['1 dag geleden', 'over 1 dag'],
		['%s dagen geleden', 'in %s dagen'],
		['1 week geleden', 'over 1 week'],
		['%s weken geleden', 'in %s weken'],
		['1 maand geleden', 'over 1 maand'],
		['%s maanden geleden', 'in %s maanden'],
		['1 jaar geleden', 'over 1 jaar'],
		['%s jaar geleden', 'in %s jaar'], ['%s jaar geleden', 'in %s jaar']
	][index];
};

export default function TimeAgo(props) {
	register('fr_FR', tradsFR);
	register('it_IT', tradsIT);
	register('es_ES', tradsES);
	register('de_DE', tradsDE);
	register('nl_NL', tradsNL);
	register('pt_PT', tradsPT);

	return format(props.date, props.lang);
}